export const SUGGEST_ASK_Q = /* GraphQL */ `
  query SuggestAsk {
    suggestAsk {
      id
      shortTitle
      description
      shareBody
      shareUrl
      godmother {
        firstName
        pictureUrl
        worksFor
      }
    }
  }
`;

export const SEND_ASK_M = /* GraphQL */ `
  mutation SendAsk($askId: ID!, $sentBody: String!) {
    sendAsk(askId: $askId, sentBody: $sentBody)
  }
`;

export const DECLINE_ASK_M = /* GraphQL */ `
  mutation DeclineAsk($askId: ID!) {
    declineAsk(askId: $askId)
  }
`;
